var l = { icon: { tag: "svg", attrs: { viewBox: "0 0 12 10", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M5.43 9.56L.6 5.11l1.38-1.5L5.2 6.6 10 .56l1.6 1.27z", "fill-rule": "nonzero" } }] }, name: "right2", theme: "filled" };
export {
  l as default
};
